import { EmailActivityWorkspace } from "@email/EmailActivityWorkspace";
import type { EmailSearch } from "@email/emailSearch";

export const EmailRoute = ({ search }: { search: EmailSearch }) => (
  <div className="mx-auto w-full max-w-7xl">
    <EmailActivityWorkspace search={search} />
  </div>
);
